import React from "react";
import AppRouter from "./components/AppRouter";
import AuthContextProvider from "./components/contexts/AuthContext";

function App() {
  return (
    <AuthContextProvider>
      <AppRouter />
    </AuthContextProvider>
  );
}

export default App;
